import { DeleteOutlined, UserOutlined } from '@ant-design/icons';
import { Avatar, Form } from 'antd';
import React, { FC } from 'react';
import { useCompositorContext } from './CompositorProvider';

interface UserAvatarProps {
    size: number,
    imageURL?: string | null,
    style?: Record<string, string>
    avatarStyle?: Record<string, string>,
    formFullname?: (string | number)[],
    showOverlayPanel?: boolean
}
export const UserAvatar: FC<UserAvatarProps> = (props) => {
    const formInstance = Form.useFormInstance()
    const { avatarShape } = useCompositorContext()
    const size = props.size || 40
    const resetField = () => {
        if(props.formFullname){
            formInstance.resetFields([props.formFullname])
        }
    }
    return (
        <div style={{
            display: 'table',
            margin: '0 auto',
            padding: '40px 0',
            ...(props.style || {})
        }}>

            {
                props.imageURL ? (
                    <div className='avatar-preview'>
                        {
                            props.showOverlayPanel && (

                                <div className='avatar-preview-overlay'>
                                <span className='button' onClick={resetField}>
                                    <DeleteOutlined aria-hidden={true}/>
                                </span>
                            </div>
                            )
                        }
                        <img
                            className='avatar-img'
                            aria-hidden={true}
                            src={props.imageURL}
                            height={`${size}px`}
                            width={`${size}px`}
                            style={{ borderRadius: avatarShape === 'square' ? '0%' : '100%' }}
                        />
                    </div>
                ) : (
                    <Avatar className="avatar user" style={props.avatarStyle} size={size} icon={<UserOutlined aria-hidden={true}/>} />
                )
            }
        </div>
    )
}